import React from "react";
import { Box } from "@mui/material";

import { Gallery } from "components/ReactActivityFeed/Gallery";
import { AttachmentDetail } from "interfaces/attachment";

interface Props {
  eventId: number;
  files: AttachmentDetail[];
}

export interface DownloadedFiles {
  mimeString: string | null;
  dataUri: string;
  name: string;
  blob: Blob;
  reader: null; // always seems to be null?
}

function StreamCardImagePreview({ eventId, files }: Props): JSX.Element {
  return (
    <Box>
      <Gallery images={files} eventId={eventId} />
    </Box>
  );
}

export default React.memo(StreamCardImagePreview);
